import { render, staticRenderFns } from "./batchOperate.vue?vue&type=template&id=4160b595&"
import script from "./batchOperate.vue?vue&type=script&lang=js&"
export * from "./batchOperate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports